import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { AurelioBuilderProvider } from "./context/AurelioBuilderContext";
import RootLayout from "./layouts/RootLayout";
import DashboardLayout from "./layouts/DashboardLayout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import ImageOptimizer from "./pages/tools/image-optimizer/ImageOptimizer";
import YoutubeDownloader from "./pages/tools/youtube-downloader/YoutubeDownloader";
import SeoMassGenerator from "./pages/tools/seo-mass/SeoMassGenerator";
import AurelioBuilder from "./pages/tools/aurelio-builder/AurelioBuilder";
import Profile from "./pages/Profile";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Replace this with your actual Google OAuth client ID
const GOOGLE_CLIENT_ID = "YOUR_GOOGLE_CLIENT_ID";

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <ThemeProvider>
          <Router>
            <Routes>
              <Route path="/" element={<RootLayout />}>
                {/* Public routes */}
                <Route index element={<Navigate to="/login" replace />} />
                <Route path="login" element={<Login />} />
                <Route path="signup" element={<Signup />} />
                
                {/* Protected routes with dashboard layout */}
                <Route
                  path="dashboard"
                  element={
                    <ProtectedRoute>
                      <AurelioBuilderProvider>
                        <DashboardLayout />
                      </AurelioBuilderProvider>
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Dashboard />} />
                  {/* Profile route */}
                  <Route path="profile" element={<Profile />} />
                  {/* Tool routes */}
                  <Route path="tools/image-optimizer" element={<ImageOptimizer />} />
                <Route path="tools/youtube-downloader" element={<YoutubeDownloader />} />
                <Route path="tools/seo-mass-generator" element={<SeoMassGenerator />} />
                  <Route path="tools/aurelio-builder/*" element={<AurelioBuilder />} />
                </Route>
              </Route>
            </Routes>
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
